<template>
  <field-element :name="name" :label="label" :state="state" :type="'dropdown alt'">
    <template v-slot:content>
      <section class="input-dropdown alt">
        <select
            ref="input"
            :value="value"
            :id="name"
            :name="name"
            :disabled="disabled"
            :required="required"
            @[(lazy?`change`:`input`)]="$emit('update:value', $event.target.value)"
        >
          <option v-if="placeholder" value="" disabled selected hidden>{{ placeholder }}</option>
          <option
              v-for="(option, index) in options"
              :key="index"
              :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
        <icon icon="x-fa-chevron-down"/>
      </section>
    </template>
  </field-element>
</template>

<script>
import fieldElement from '../../_shared/field.vue';
import fieldMixin from '../../_shared/fieldMixin.js';
import Icon from '../../../icon/Icon.vue';

export default {
  name: 'fieldDropdownAlt',
  components: {
    fieldElement,
    Icon
  },
  mixins: [
    fieldMixin,
  ],
  props: {
    options: Array
  },
  mounted() {
    if (this.value === null) {
      this.$emit('update:value', this.options[0].value);
    }
  }
};
</script>
